<template>
    <Head title="Login - Invelo" />
    <LayoutNewGuest>
        <LayoutNewGuestHeading
            heading="Welcome"
            subtext="Sign in with your credentials below."
        />
        <div
            v-if="status"
            class="mb-4 font-medium text-sm text-green-600"
        >
            {{ status }}
        </div>
        <div
            v-if="error"
            class="mb-4 font-medium text-sm text-red-600"
        >
            {{ error }}
        </div>
        <form
            class="space-y-4 w-full"
            @submit.prevent="login"
        >
            <div class="w-full">
                <label
                    for="email"
                    class="block text-base leading-6 text-gray-900 dark:text-gray-200"
                >
                    Email address <span class="text-red-500">*</span>
                </label>
                <div class="mt-2 w-full">
                    <InputText
                        v-model="form.email"
                        type="text"
                        fluid
                        required
                        class="rounded-full text-left hover:border-inveloPurple"
                        placeholder="Enter your email"
                    />
                    <div
                        v-if="form.errors.email"
                        class="text-sm text-red-500"
                    >
                        {{ form.errors.email }}
                    </div>
                </div>
            </div>
            <div class="w-full">
                <div class="flex items-center justify-between">
                    <label
                        for="password"
                        class="block text-base leading-6 text-gray-900 dark:text-gray-200"
                    >
                        Password <span class="text-red-500">*</span>
                    </label>
                </div>
                <div class="mt-2 w-full">
                    <div class="relative">
                        <InputText
                            v-model="form.password"
                            type="password"
                            fluid
                            required
                            class="rounded-full "
                            placeholder="Enter password"
                        />
                        <Link
                            :href="route('password.request')"
                            class="hover:no-underline absolute top-3 right-6 underline text-xs md:text-sm text-inveloPurple"
                        >
                            Forgot password?
                        </Link>
                    </div>
                    <div
                        v-if="form.errors.password"
                        class="text-sm text-red-500"
                    >
                        {{ form.errors.password }}
                    </div>
                </div>
            </div>
            <div class="w-full text-center">
                <LayoutNewGuestSubmitButton
                    label="Sign In"
                    :loading="form.processing"
                    :disabled="form.processing"
                />
            </div>
        </form>
        <LayoutNewGuestSocialLogin />
        <LayoutNewGuestSignUp />
    </LayoutNewGuest>
</template>

<script setup>
import { Link } from '@inertiajs/vue3';

const props = defineProps({
    status: String,
    error: String,
});

const form = useForm({
    email: null,
    password: null,
});

const login = () => {
    localStorage.setItem('hubspot-token', null);
    form.post(route('central.auth.login'), {
        preserveScroll: true,
    });
};
</script>
